import { cn } from '@/lib/utils';

export interface SidebarClassNames {
  sidebarClassName: string;
  headerClassName: string;
  navClassName: string;
  collapseTooltip: string;
}

export function getSidebarClassNames(
  isCollapsed: boolean,
  isMobileOpen: boolean
): SidebarClassNames {
  return {
    sidebarClassName: cn(
      'fixed inset-y-0 left-0 z-40 flex flex-col border-r bg-card transition-all duration-300 md:static md:translate-x-0',
      isCollapsed ? 'w-16' : 'w-64',
      isMobileOpen ? 'translate-x-0' : '-translate-x-full'
    ),
    headerClassName: cn(
      'flex h-16 items-center border-b cursor-pointer hover:bg-muted transition-colors',
      isCollapsed ? 'justify-center px-2' : 'gap-2 px-6'
    ),
    navClassName: cn(
      'flex-1 py-4',
      isCollapsed ? 'flex flex-col items-center space-y-2' : 'space-y-1 px-3'
    ),
    collapseTooltip: isCollapsed ? 'Expand sidebar' : 'Collapse sidebar',
  };
}
